
(function($) {
   
    //Aos Animation

    AOS.init({
        offset: 200,
        duration: 800,
        disable: 'mobile',
        easing: 'ease-in-quad',
        delay: 100,
    });

     // on Scroll logo resize
    /*  Header onscroll background-color */
    //$(function() {
        $(window).on("scroll", function() {
            if ($(window).scrollTop() > 50) {
                $(".navbar").addClass("fixed-top-zero");
                $(".navbar-top").addClass("none-navbar");
            } else {
                //remove the background property so it comes transparent again (defined in your css)
                $(".navbar").removeClass("fixed-top-zero");
                $(".navbar-top").removeClass("none-navbar");
            }
        });
  
})(jQuery);